import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';

import en from './languages/en.json';
import pt from './languages/pt.json';
import es from './languages/es.json';
import de from './languages/de.json';
import it from './languages/it.json';
import fr from './languages/fr.json';
import ja from './languages/ja.json';

import { makeZodI18nMap } from 'zod-i18n-map';
import { z } from 'zod';

const cookieLang = Cookies.get('mundpay-locale');
const supportedLanguages = ['pt', 'en', 'es', 'de', 'it', 'fr', 'ja'];

const browserLang = navigator.language?.split('-')[0];

const detectedLang = supportedLanguages.includes(browserLang) ? browserLang : 'pt';

const initialLang = supportedLanguages.includes(cookieLang ?? '') ? cookieLang! : detectedLang;

const ns = Object.keys(en);
export const defaultNS = ns[0];

i18n.use(initReactI18next).init({
  ns,
  defaultNS,
  resources: {
    en,
    pt,
    es,
    de,
    it,
    fr,
    ja
  },
  lng: initialLang,
  fallbackLng: 'pt',
  interpolation: {
    escapeValue: false,
  },
  compatibilityJSON: 'v3',
});

z.setErrorMap(makeZodI18nMap({ ns: ['zod', 'validation'] }));
export { z };

export const changeLanguage = (lang: string) => {
  i18n.changeLanguage(lang);
  Cookies.set('mundpay-locale', lang);
};

export default i18n;
